import routerOptions0 from "/usr/src/app/content/n3-packages-cf355189-79cb-4aa6-ac18-d6ec89530086/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}